// extracted by mini-css-extract-plugin
module.exports = {"section":"_2O4ZBbCiQLkRKySk3ZuwDA","inner":"_2kE-SvP6AFHDf4PbYp5b5G"};